export type ActivityRoleType = "checker" | "approver" | "executor" | "cc";

export const getRoleStatus = (
  role: ActivityRoleType,
  {
    isBypassed,
    isDone,
    status,
  }: { isBypassed: boolean; isDone: boolean; status: string },
): string => {
  if (role === "cc") return "CC";
  if (isBypassed) return "Bypassed";

  const roleStatus: Record<ActivityRoleType, () => string> = {
    checker: () => (isDone ? "Checked" : "Will Check"),
    approver: () => status === "rejected" ? "Rejected" : isDone ? "Approved" : "Will Approve",
    executor: () => (isDone ? "Executed" : "Will Execute"),
    cc: () => "CC",
  };

  return roleStatus[role]();
};
